import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getNumberParts } from '../../service/FormatHelpers/FormatHelpers';

import './PercentText.css';

interface Props {
    num?: number;
    fractionalPartLength?: number;
}

export class PercentText extends React.Component<Props> {
    render() {
        const { num, fractionalPartLength = 2 } = this.props;
        const formattedNumberParts = getNumberParts(
            Number(num),
            fractionalPartLength
        );
        let fractionalPart;

        if (formattedNumberParts.fractionalPart) {
            fractionalPart = (
                <span>
                    {formattedNumberParts.decimalPointSign}
                    {formattedNumberParts.fractionalPart}
                </span>
            );
        } else {
            fractionalPart = '';
        }

        return (
            <span className={Bem.cls('percent-text')}>
                {formattedNumberParts.integerPart}
                <span
                    className={Bem.cls({
                        block: 'percent-text',
                        elem: 'highlight'
                    })}
                >
                    {fractionalPart}
                    {' %'}
                </span>
            </span>
        );
    }
}
